
  Vue.component('abb-menu-coupon', {
    props: {
      subscriptionCoupon: {
        type: Object,
        default: () => {}
      },
      handleCoupon: { type: Function, required: true }
    },
    data() {
      return {
        formInterfaces: {}
      }
    },
    template: '#abb-menu-coupon',
    computed: {
      hasCoupon() {
        return Object.keys(this.subscriptionCoupon).length > 0
      },
      couponFormConfig() {
        const self = this
        return [
          {
            id: 0,
            fieldName: 'CouponCode',
            inputType: 'input',
            label: 'Codice Coupon XXX',
            validators: [
              {
                type: 'required',
                message: 'Inserire un codice Coupon'
              },
              {
                type: 'regex',
                regex: /[a-zA-Z0-9]{8}/,
                message: 'Il codice Coupon non è valido'
              },
              {
                type: 'remote',
                method: 'post',
                url: '/api/v1/utilities/isValidCoupon',
                message: 'Il codice Coupon non è valido o è scaduto'
              }
            ]
          },
          {
            id: 1,
            fieldName: 'CouponButton',
            inputType: 'button',
            label: 'Aggiungi',
            action: () => this.handleCouponClick()
          }
        ]
      }
    },
    watch: {},
    methods: {
      handleCouponClick() {
        const key = 'CouponCode'
        if (this.formInterfaces[key].validate()) {
          const { CouponCode } = { ...this.formInterfaces[key].getValues() }
          this.handleCoupon(CouponCode)
        }
      },
      getFormInterface(formInterface) {
        this.formInterfaces[formInterface.key] = formInterface
      }
    },
    mounted() {}
  })
